export const userManagementNew = "new";
export const userManagementPathResources = {
    users: "users",
    teams: "teams",
    skills: "skills",
    customAttributes: "custom-attributes",
    newUser: `users/${userManagementNew}`,
    editUser: "users/:userId",
    newTeam: `teams/${userManagementNew}`,
    editTeam: "teams/:teamId",
    newSkill: `skills/${userManagementNew}`,
    editSkill: "skills/:skillId",
    newCustomAttribute: `custom-attributes/${userManagementNew}`,
    editCustomAttribute: "custom-attributes/:attributeId",
} as const;
